import { Logo } from "@/components/Logo";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2 bg-background">
      {/* left form */}
      <div className="flex flex-col justify-center px-6 py-12 sm:px-12 lg:px-20">
        <div className="mx-auto w-full max-w-sm">
          <Logo />
          <h1 className="mt-10 text-3xl font-semibold tracking-tight text-zinc-50">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-zinc-400">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-zinc-500">{footer}</div>}
        </div>
      </div>
      {/* right visual */}
      <div className="relative hidden overflow-hidden border-l border-zinc-800 lg:block">
        <div className="absolute inset-0 grid-bg opacity-60" />
        <div
          className="absolute inset-0 bg-cover bg-center opacity-25"
          style={{
            backgroundImage:
              "url(https://images.unsplash.com/photo-1714548529197-537c1f0b6aa7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400)",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/40 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12">
          <div className="inline-flex items-center gap-2 rounded-full border border-zinc-700 bg-zinc-900/70 px-3 py-1 text-xs text-zinc-300 backdrop-blur">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 animate-pulse" /> Real-time media infrastructure
          </div>
          <p className="mt-6 max-w-md text-2xl font-medium leading-snug text-zinc-100">
            Ship live audio, video & screenshare in under 15 minutes — without touching WebRTC.
          </p>
          <p className="mt-3 font-mono text-xs text-zinc-500">
            API + SDK · Multi-tenant · Usage metering · Provider-agnostic
          </p>
        </div>
      </div>
    </div>
  );
}
